<template>
	<section>
		<!-- Main submenu -->
		<nav class="main-submenu header__main-submenu">
			<div class="row">

				<div class="columns small-12 medium-12 large-12" v-if="isDoctor">
					<ul class="main-submenu__list clear_fix">
						<li class="main-submenu___item">
							<router-link activeClass="main-submenu__active" :to='{name:"Own", params:{id: user._id}}'
													 class="main-submenu__link trans">
								Мой кабинет
							</router-link>
						</li>

						<!--<li class="main-submenu___item">
							<router-link :to='{name:"Message"}' class="main-submenu__link trans">Сообщения</router-link>
						</li>-->

						<li class="main-submenu___item">
							<router-link activeClass="main-submenu__active" :to='{name:"Patients", params: {clinic: clinic._id}}'
													 class="main-submenu__link trans">
								Клиника
							</router-link>
						</li>

						<li class="main-submenu___item">
							<router-link activeClass="main-submenu__active" :to='{name:"Registry", params: {clinic: clinic._id}}' class="main-submenu__link trans">
								Регистратура
							</router-link>
						</li>

						<li class="main-submenu___item">
							<router-link activeClass="main-submenu__active" :to='{name:"GeneralSchedule", params: {clinic: clinic._id}}' class="main-submenu__link trans">
								Общее расписание
							</router-link>
						</li>
					</ul>
				</div>

				<div class="columns small-12 medium-12 large-12" v-else>
					<ul class="main-submenu__list clear_fix">
						<li class="main-submenu___item">
							<router-link activeClass="main-submenu__active" :to='{name:"Own", params:{id: user._id}}'
													 class="main-submenu__link trans">
								Мой кабинет
							</router-link>
						</li>

						<!--<li class="main-submenu___item">
							<router-link :to='{name:"Message"}' class="main-submenu__link trans">Сообщения</router-link>
						</li>-->

						<li class="main-submenu___item">
							<router-link activeClass="main-submenu__active" :to='{name:"Card"}' class="main-submenu__link trans">
								Карточка
							</router-link>
						</li>

						<!--<li class="main-submenu___item">
							<router-link :to='{name:"Nurse"}' class="main-submenu__link trans">Медсестра</router-link>
						</li>-->
					</ul>
				</div>

			</div>
		</nav>
		<!-- Main submenu End -->

		<router-view></router-view>

	</section>
</template>

<script>
	export default {
		name: "Cabinet",
		computed: {
			isDoctor() {
				return this.$store.state.auth.isDoctor
			},
			user() {
				if(this.$store.state.auth.isDoctor) {
					return this.$store.state.auth.worker
				}

				return this.$store.state.auth.user
			},
			clinic() {
				return this.$store.state.auth.clinic
			}
		},
		mounted() {
			this.$router.push({
				name: 'Events'
			})
		}
	}
</script>
<style>
	.main-submenu__active {
		text-decoration: underline;
	}
</style>



// WEBPACK FOOTER //
// Cabinet.vue?5bac5609